import { render } from "./CoreComponent.vue?vue&type=template&id=2c5c7403"
import script from "./CoreComponent.vue?vue&type=script&lang=js"
export * from "./CoreComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../dow-corp/ui.frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__